import { PureComponent } from 'react';
import { Route, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getDisplayName, isEmpty } from '../../utils';
import { getEditRoutePathParams } from '~/routes/helpers';
import { setEditMode } from '../../routes/edit/common/edit-appointment.actions';
import { envConfigSelectors } from '~/components';

export class EditRoute extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
    temporaryAppointment: PropTypes.shape({}).isRequired,
    dispatchSetEditMode: PropTypes.func.isRequired,
    component: PropTypes.func.isRequired,
    firstEditPagePath: PropTypes.string.isRequired,
  };

  static displayName = `WithEdit(${getDisplayName(Route)})`;

  componentDidMount() {
    const { firstEditPagePath, history, temporaryAppointment, dispatchSetEditMode } = this.props;

    if (isEmpty(temporaryAppointment)) {
      const {
        location: { pathname },
      } = history;
      const {
        params: { appointmentId },
      } = getEditRoutePathParams(pathname);
      if (pathname.indexOf(firstEditPagePath) === -1) {
        history.replaceWithToken({
          pathname: appointmentId ? `/${appointmentId}${firstEditPagePath}` : firstEditPagePath,
        });
      }
    }
    dispatchSetEditMode(true);
  }

  render() {
    const { component: Component, ...routeProps } = this.props;
    return <Route {...routeProps} render={(props) => <Component {...props} {...routeProps} />} />;
  }
}

export const mapStateToProps = (state) => {
  const {
    appointment: {
      draft: {
        appointmentType: { id: appointmentTypeId },
      },
    },
    editAppointment: { temporaryAppointment },
  } = state;
  return {
    firstEditPagePath: envConfigSelectors.selectFirstEditPage(appointmentTypeId)(state),
    temporaryAppointment,
  };
};

const mapDispatchToProps = {
  dispatchSetEditMode: setEditMode,
};

export const ConnectedEditRoute = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditRoute),
);
